import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'educare-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  imports: [CommonModule]
})
export class TooltipComponent {
  @Input() text = '';
  position: { top: string; left: string } | null = null;
  isVisible = false;

  showTooltip(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    let top = rect.top + window.scrollY - 10;
    let left = rect.left + rect.width / 2 + window.scrollX;
    if (screenWidth >= 993 && screenWidth <= 1300) {
      const zoomFactor = 0.8; //current body zoom level
      const adjustedX = event.pageX / zoomFactor;
      const adjustedY = event.pageY / zoomFactor;
      top = adjustedY - 20; // offset
      left = adjustedX;
    }
    this.position = {
      top: `${top}px`,
      left: `${left}px`
    };

    this.isVisible = true;
  }

  hideTooltip() {
    this.isVisible = false;
  }
}
